import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import { nullable, ref, string } from "../../../types/_types";

import { OrganizationRef } from "../../organizations/types/OrganizationRef";

export const Serie = FirestoreDocument.extend({
	name: string(1),
	description: nullable(string()),
	publisher: OrganizationRef,
}).merge(FirestoreLifecycle);

export const SerieRef = ref(Serie, {
	name: true,
	description: true,
});
